import { AuthUser, UserCountry } from '@core/domain/model/user/auth-user.model';

export interface UserState {
  user: AuthUser | null;
  country: null | UserCountry;
  multipleCountries: boolean | null;
  error: string | null;
  waitingForCountry: boolean;
  waitingForDataProtection: boolean;
  impersonationToken: string | null;
  isEnergyRehabilitationMode: boolean;
}

export const userInitialState: UserState = {
  user: null,
  country: null,
  multipleCountries: null,
  error: null,
  waitingForCountry: false,
  waitingForDataProtection: false,
  impersonationToken: null,
  isEnergyRehabilitationMode: false,
};
